export const isBrowser = () => typeof window !== 'undefined';
// Chrome 1+
// @ts-expect-error ts-migrate(2339) FIXME: Property 'chrome' does not exist on type 'Window &... Remove this comment to see the full error message
export const isChrome = () => isBrowser() && !!window.chrome;
export const setScrollRestorationManual = () => {
  // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
  if ('scrollRestoration' in window.history) {
    // Try / catch for scrollRestoration writable: https://github.com/taion/scroll-behavior/issues/126
    try {
      // Back off, browser, I got this...
      window.history.scrollRestoration = 'manual';
    } catch (e) {
      /* silence */
    }
  }
};
